module.exports = __webpack_public_path__ + "static/media/peds-ral26.b3217ef2.png";